



export const trackAddedPotentialRecruitment = (eventProps = {}) => {
    if (eventProps["Facesheet ID"] && eventProps["Source"] && eventProps["Create Date"] && eventProps["Latest Meeting Date"]) {
        const tracking = require("../../tracking").tracking;
        tracking('Added Potential Recruitment', eventProps)
    }
}